export const buildDishAttributeSchema = (storeDishAttributes) => {
  const schema = {
    title: ' ',
    type: 'object',
    required: [],
    properties: {},
    options: { disable_collapse: true, collapsed: false },
  };
  const required = [];

  storeDishAttributes.forEach((attribute) => {
    const catName = (attribute.storeAttributeName && attribute.storeAttributeName.name) || (attribute.store_attribute_name && attribute.store_attribute_name.name) || 'Category';
    const name_attribute = catName.toLowerCase().replace(/ /g, '_');
    required.push(name_attribute);

    const property = {
      type: 'array',
      format: 'table',
      title: catName,
      uniqueItems: true,
      options: { collapsed: true },
      items: {},
    };

    if (!schema.properties[name_attribute]) {
      schema.properties[name_attribute] = property;
    }

    const items = {
      type: 'object',
      title: catName,
      properties: {},
    };
    if (!schema.properties[name_attribute].items.title) {
      schema.properties[name_attribute].items = items;
    }

    const property_name = (attribute.name || '').toLowerCase().replace(/ /g, '_');
    const property_type = attribute.type !== 'number' ? 'string' : 'number';
    
    let parsedValues = attribute.values;
    if (typeof parsedValues === 'string') {
      try { parsedValues = JSON.parse(parsedValues); } catch(e) {}
    }

    const hasValues = parsedValues && parsedValues.value && Array.isArray(parsedValues.value) && parsedValues.value.length > 0;

    if (!schema.properties[name_attribute].items.properties[property_name]) {
      schema.properties[name_attribute].items.properties[property_name] = {
        type: property_type,
      };
      if (hasValues) {
        schema.properties[name_attribute].items.properties[property_name].enum = parsedValues.value.map(val => val.name);
      }
      
      if (attribute.type === 'number') {
        schema.properties[name_attribute].items.properties[property_name].format = 'number';
      }

      if (property_type === 'number') {
        schema.properties[name_attribute].items.properties[property_name].minimum = 0;
      }
    }

    // attribute properties
    schema.properties[`${name_attribute}_properties`] = {
      type: 'array',
      format: 'table',
      title: `${catName} properties`,
      uniqueItems: true,
      options: { collapsed: true },
      items: {
        type: 'object',
        title: `${catName} properties`,
        properties: {
          type: {
            type: 'string',
            description: 'Choose if attribute is single or multiple selection.',
            enum: ['single', 'multiple'],
            default: 'single',
          },
          max: {
            type: 'integer',
            format: 'number',
            description: 'This field only works for multiple selection.',
            minimum: 1,
            maximum: 99,
          },
          mandatory: {
            type: 'string',
            description: 'Choose if attribute is mandatory.',
            enum: ['true', 'false'],
            default: 'false',
          },
          order: {
            type: 'integer',
            format: 'number',
            description: 'display order.',
            minimum: 0,
            maximum: 200,
          },
        },
      },
      default: [
        {
          type: 'single',
          max: 1,
          mandatory: 'false',
          order: 0,
        },
      ],
    };
    required.push(`${name_attribute}_properties`);
  });

  schema.required = [...new Set(required)];
  return schema;
};
